import {
  GET_OUTLET_DETAILS_FAILD,
  GET_OUTLET_DETAILS_LOADING,
  GET_OUTLET_DETAILS_SUCCESS,
} from "../types";

const initialState = {
  outletDetails: null,
  loading: false,
  error: null,
};

export const outletDetailsReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_OUTLET_DETAILS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_OUTLET_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        outletDetails: action.payload,
      };
    case GET_OUTLET_DETAILS_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
